import React from 'react';
import { FinancingPerMonthComponent } from '../../../themes/mattressfirm/custom-components/financing-per-month-component';
import { IBuyboxViewPropsExtended } from '../types';
import { IMfrmBuyboxProps } from '../mfrm-buybox.props.autogenerated';
import { IMfrmBuyBoxData } from '../mfrm-buybox.view';

export const BuyboxFinancingPerMonth = (
    props:{
        buyboxProps: IBuyboxViewPropsExtended & IMfrmBuyboxProps<IMfrmBuyBoxData>,
        originalPrice: number | undefined,
        discountValue: number | undefined,
        productPrice: number | undefined,
        categoryName: string | undefined,
        activeVariantId: number | undefined,
        productId: number | undefined,
        activeColorVariantId: number | undefined,
        isLoadedPriceComponent: boolean | undefined,
        parentCategory?: string | undefined
    }
): JSX.Element => {
    const {
        buyboxProps,
        originalPrice,
        discountValue,
        productPrice,
        categoryName,
        activeVariantId,
        productId,
        activeColorVariantId,
        isLoadedPriceComponent,
        parentCategory
    } = props;
    const percentageDiscount = discountValue && originalPrice && (discountValue / originalPrice) * 100;
    return (
        <FinancingPerMonthComponent
            pageType='PDP'
            sellingPrice={productPrice || 0}
            context={buyboxProps.context}
            dimensionPrice={originalPrice}
            percentDiff={percentageDiscount}
            discountAmount={discountValue}
            categoryName={categoryName}
            activeVariantId={activeVariantId}
            productId={productId}
            activeColorVariantId={activeColorVariantId}
            isLoadedPriceComponent={isLoadedPriceComponent}
            parentCategory={parentCategory}
        />
    );
};